import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const PanduanLayanan = () => {
    const panduanLayanan = useSelector(state => state.data.panduanLayanan);

    return (
        <section className="py-16 bg-white">
            <div className="container mx-auto px-4">
                <h2 className="section-title">Panduan Layanan</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
                    {panduanLayanan.map((panduan) => (
                        <div key={panduan.id} className="card-glass">
                            <h3 className="text-2xl font-bold text-[#1E3A8A] mb-4">{panduan.title}</h3>

                            {panduan.steps && (
                                <ol className="space-y-3 mb-6">
                                    {panduan.steps.map((step, index) => (
                                        <li key={index} className="flex items-start">
                                            <span className="flex-shrink-0 w-8 h-8 bg-[#0D9488] text-white rounded-full flex items-center justify-center font-bold mr-3">
                                                {index + 1}
                                            </span>
                                            <span className="text-gray-700 pt-1">{step}</span>
                                        </li>
                                    ))}
                                </ol>
                            )}

                            {panduan.contacts && (
                                <div className="space-y-3 mb-6">
                                    {panduan.contacts.map((contact, index) => (
                                        <div key={index} className="flex items-center space-x-3 text-gray-700">
                                            <span className="font-semibold capitalize">{contact.type}:</span>
                                            <span>{contact.value}</span>
                                        </div>
                                    ))}
                                </div>
                            )}

                            <Link to={panduan.link} className="btn-primary inline-block">
                                Selengkapnya
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PanduanLayanan;